import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'neoris-minidashboard-dz',
  templateUrl: './minidashboard-dz.component.html',
  styleUrls: ['./minidashboard-dz.component.css']
})
export class MinidashboardDzComponent implements OnInit {
  
  siteId:string
  
  constructor() { 
    console.log('minidashboard constructor')
  }

  ngOnInit(): void {
    this.siteId = localStorage.getItem('site')
  }

}
